import Seo from "@/components/Seo";
import WhatsAppCTA from "@/components/WhatsAppCTA";

const NotFoundPage = () => (
  <main data-testid="page-404" className="max-w-3xl mx-auto px-4 py-24 text-center">
    <Seo
      title="Page Not Found | Nursing Home in Penang"
      description="The page you are looking for could not be found. Browse our Penang nursing home directory or contact us for free assistance."
      path="/404"
    />
    <p className="font-accent text-7xl text-brand-gold">404</p>
    <h1 className="mt-4 font-display text-3xl sm:text-4xl font-bold text-brand-charcoal">This page has moved or does not exist</h1>
    <p className="mt-4 text-slate-600 leading-relaxed">
      Let us guide you back — browse the directory, read our guides, or message us for free help finding a suitable
      nursing home in Penang.
    </p>
    <div className="mt-8 flex flex-wrap justify-center gap-4">
      <a href="/" data-testid="notfound-home-link" className="inline-flex items-center rounded-full bg-brand-teal px-6 py-3 text-sm font-semibold text-white hover:bg-brand-gold transition-colors">
        Back to Homepage
      </a>
      <WhatsAppCTA testid="notfound-whatsapp-cta" variant="gold" />
    </div>
  </main>
);

export default NotFoundPage;
